import { Icon } from 'semantic-ui-react';

export const setTransferIcon = (row) => {
  const {
    prior_admission_id,
    manual_link_encounter_next_encounter_id,
    manual_link_encounter_prior_encounter_id,
  } = row._original;
  if (prior_admission_id || manual_link_encounter_prior_encounter_id) {
    return <Icon color='blue' name='chevron circle left' />;
  }

  if (manual_link_encounter_next_encounter_id) {
    return <Icon color='blue' name='chevron circle right' />;
  }

  return null;
};
